<template>
  <div>
    <MasterLayout>
      <section class="full__row_section first__row">
        <div class="row">
          <div class="col-md-4">
            <div class="dashboard__card large_card indus_back_img">
              <div
                class="row make-row-hundred-percent align-items-center justify-content-center"
              >
                <div class="col-md-3">
                  <div
                    class="icon_wrapper yellow centralize icon_div_big"
                    style=""
                  >
                    <img src="@/assets/img/oil-truck.svg" width="" />
                  </div>
                </div>
                <div class="col-md-7 remove-padding-left" ref="padding_div">
                  <div class="text-center">
                    <h6 class="text-white">
                      {{ $t("text.iRequestDiesel.numberOfOrders") }}
                    </h6>
                  </div>
                  <div class="text-center mt-4">
                    <h5 class="text-white mt-4 font-weight">
                      {{ orderCount }}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-md-8 remove-padding-left padding_div"
            ref="padding_div"
          >
            <div class="dashboard__card small_card align-center">
              <div class="card_inner_wrapper">
                <!-- <div class="card_inner_wrapper_header_container">
                                
                            </div> -->
                <div class="row make-row-hundred-percent">
                  <div class="col-md-9">
                    <h3 class="card_inner_wrapper_header">
                      {{ $t("text.iRequestDiesel.hi") }}, {{ userName }}
                    </h3>
                    <h3 class="card_inner_wrapper_para mt-4">
                      {{ $t("text.iRequestDiesel.requestText") }}
                    </h3>
                  </div>
                  <div class="col-md-3 mt-4">
                    <router-link
                      :to="{
                        name: 'IndusrialBranchAddOrder',
                        query: this.$route.query.branchId
                          ? this.linkQuery
                          : ' ',
                        groupId: this.$route.query.groupId,
                      }"
                      class="vue_router_link btn btn_theme yellow_text"
                    >
                      {{ $t("text.iRequestDiesel.requestDiesel") }}
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="first__row full__row_section">
        <ejs-grid
          ref="dataGrid"
          v-show="!showLoader"
          :created="refreshGrid"
          :allowPaging="true"
          :allowSorting="true"
          :pageSettings="pageSettings"
          :toolbar="toolbar"
          :searchSettings="search"
          :allowExcelExport="true"
          :allowPdfExport="true"
          :toolbarClick="toolbarClick"
          :locale="usedLang"
        >
          <e-columns>
            <e-column field="index" width="40" headerText="#"></e-column>
            <e-column
              field="date"
              width="200"
              :headerText="$t('text.iRequestDiesel.date')"
            ></e-column>
            <e-column
              field="quantity"
              width="200"
              :headerText="$t('text.iRequestDiesel.volume')"
            ></e-column>
            <e-column
              field="price"
              width="150"
              :headerText="$t('text.iRequestDiesel.price')"
            ></e-column>
            <e-column
              field="productName"
              width="150"
              :headerText="$t('text.iRequestDiesel.product')"
            ></e-column>
            <e-column
              field="amount"
              width="200"
              :headerText="
                $t('text.iRequestDiesel.amount', {
                  currency: `(${
                    industryBranch ? industryBranch.currency : ''
                  })`,
                })
              "
            ></e-column>
            <e-column
              :template="statusTemplate"
              field="status"
              width="350"
              :headerText="$t('text.iRequestDiesel.status')"
            ></e-column>
            <e-column
              :template="trackOrderTemplate"
              width="350"
              :headerText="$t('text.actionButtons.title')"
            ></e-column>
          </e-columns>
        </ejs-grid>
        <TableLoader :showLoader="showLoader" />
      </section>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Industrial/MasterLayout.vue";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import { Chart } from "highcharts-vue";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import backImg from "@/assets/img/pattern_img.png";
import { VueApexCharts } from "apexcharts";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";
import countryProducts from "@/products";

import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";

import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Request Diesel:: Epump Industrial Portal",
  name: "TrackOrder",
  components: {
    MasterLayout,
    Highcharts: Chart,
    VueApexCharts,
    VueperSlides,
    VueperSlide,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      // countryProducts: localStorage.getItem('countryProducts') ? JSON.parse(localStorage.countryProducts) : countryProducts,
      linkQuery: {
        branchId: this.$route.query.branchId,
        companyId: this.$route.query.companyId,
        groupId: this.$route.query.groupId,
      },
      backImg,
      industryBranch: null,
      industryBranchId: null,
      orderCount: 0,
      showLoader: true,
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["Search"],
      userDetails: localStorage.getItem("userDetails")
        ? JSON.parse(localStorage.getItem("userDetails"))
        : null,
      startDate: this.$moment().subtract(61, "days").format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      search: { operator: "contains", ignoreCase: true },
      trackOrderTemplate: function () {
        return {
          template: Vue.component("trackOrderTemplate", {
            template:
              "<div>" +
              '<a class="btn btn_primary mr-2" style="background: #f19b15 !important;color: antiquewhite; font-size: 15px !important " :href="`/Industrial/Branch/Track-Order?branchId=${this.branchId}&groupId=${this.groupId}&companyId=${this.companyId}&id=` + data.id"  @click="linkUp($event, \'industrialBranchTrackOrder\', data)"  ><i class="fa fa-thumb-tack mr-2" style="color: white" aria-hidden="true"></i>{{data.trackOrder}}</a>' +
              '<a class="btn btn_theme" v-if="data.status === `Payment Pending`" style="background: #0f9c58 !important;font-size: 15px !important" :href="`/Industrial/Branch/Track-Order?branchId=${this.branchId}&groupId=${this.groupId}&companyId=${this.companyId}&id=` + data.id"  @click="linkUp($event, \'industrialBranchCompleteOrder\', data)"  ><i class="fa fa-check-circle mr-2" aria-hidden="true" style="color: white"></i>{{data.completeOrder}}</a>' +
              "</div>",
            data: function () {
              return {
                data: {},
                branchId: this.$route.query.branchId
                  ? this.$route.query.branchId
                  : null,
                companyId: this.$route.query.companyId
                  ? this.$route.query.companyId
                  : null,
                groupId: this.$route.query.groupId
                  ? this.$route.query.groupId
                  : null,
              };
            },
            methods: {
              linkUp($event, url, data) {
                $event.preventDefault();
                this.$eventHub.$emit("link", url, data);
              },
            },
          }),
        };
      },
      statusTemplate: function () {
        return {
          template: Vue.component("statusTemplate", {
            template:
              "<div>" +
              '<div v-if="data.status === `Payment Pending`" class="clearfix clearfix_m_table pb-4 mt-2" style="width: 70%; margin: 0 auto;">' +
              '<div class="left_div">' +
              '<span class="round_yellow_pointer"></span>' +
              "</div>" +
              '<div class="">' +
              '<span class="" style="color: #FCD462">{{data.status}}</span>' +
              "</div>" +
              "</div>" +
              '<div v-if="data.status === `Payment Completed`" class="clearfix clearfix_m_table pb-4 mt-2" style="width: 70%; margin: 0 auto;">' +
              '<div class="left_div">' +
              '<span class="green_round_pointer"></span>' +
              "</div>" +
              '<div class="">' +
              '<span class="" style="color: #1BC167">{{data.status}}</span>' +
              "</div>" +
              "</div>" +
              "</div>",
            data: function () {
              return {
                data: {},
              };
            },
            methods: {},
          }),
        };
      },
    };
  },
  created() {
    this.$eventHub.$on("industryBranch", (industryBranch) => {
      this.industryBranch = industryBranch;
    });
    this.$eventHub.$on("link", (url, data) => {
      if (this.$route.name == url) {
        return;
      }
      this.$router.push({
        name: url,
        query: {
          id: data.id,
          branchId: this.$route.query.branchId,
          groupId: this.$route.query.groupId,
          companyId: this.$route.query.companyId,
        },
      });
    });
  },
  computed: {
    countryProducts: function () {
      return this.$store.getters.getCountryProducts;
    },
    userName() {
      if (localStorage.getItem("userDetails")) {
        return this.userDetails.firstName + "  " + this.userDetails.lastName;
      } else {
        return "Username";
      }
    },
    countryProducts: function () {
      return this.$store.getters.getCountryProducts;
    },
  },
  watch: {
    industryBranch: function (newIndustry, oldIndustry) {
      if (newIndustry.id !== null) {
        this.industryBranchId = newIndustry.id;
        $(".e-input").keyup(function (e) {
          searchFun(e);
        });
        function searchFun(event) {
          var grid =
            document.getElementsByClassName("e-grid")[0].ej2_instances[0];
          var value = event.target.value;
          grid.search(value);
        }
        this.getOrders();
      }
    },
  },
  mounted() {
    if (screen.width <= 575) {
      document
        .querySelector(".padding_div")
        .classList.remove("remove-padding-left");
      document.querySelector(".padding_div").style.marginTop = "15px";
      this.$refs.padding_div.classList.remove("remove-padding-left");
    }
  },

  methods: {
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      if (this.$refs.dataGrid) {
        this.$refs.dataGrid.refresh();
      }
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getOrders() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Industrial/Orders/${this.industryBranch.id}?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.orderCount = response.data.length;
          //console.log(this.orderCount)
          this.showLoader = false;
          let index = 0;
          response.data.forEach((el, i) => {
            el.index = ++index;
            el.date = this.$moment(el.date).format("MMM D, YYYY");
            el.quantity = this.convertThousand(el.quantity);
            el.price = this.convertThousand(el.price);
            el.amount = this.convertThousand(el.amount);
            el.trackOrder = this.$t("text.iRequestDiesel.trackOrder");
            el.completeOrder = this.$t("text.iRequestDiesel.completeOrder");
          });
          this.showLoader = false;
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
  },
};
</script>
